import React from "react";
import PropTypes from 'prop-types';
import { Col, Row } from "react-bootstrap";
import { SvgIcon } from "@mui/material";
import "./Statistics.scss";

export default function Statistics(props) {

  const { points, footer } = props.data;

  return (
    <Row className={`statistics-container lightBackground`}>
      <Col>
        <Row className="section-content">
          {points.map((point, index) => <div key={index} className="section-item">
            <div className="icon-wrapper">
              <div className="icon-container">
                <SvgIcon component={point.icon} color="primary" style={{ fontSize: 40 }} />
              </div>
            </div>
            <div className="content">
              <h3 className="primary-color">{point.value}<span>%</span></h3>
              <p>{point.paragraph}</p>
            </div>
          </div>)}
        </Row>
        <Row className="section-footer">
          <p>{footer.paragraph}</p>
        </Row>
      </Col>
    </Row>
  )
}

Statistics.propTypes = {
  data: PropTypes.shape({
    points: PropTypes.array,
    footer: PropTypes.object,
  })
}
